<div class="menu-container">
  <mat-icon class="menu-icon cursor-pointer" [ngStyle]="{ color: menuColor }" role="button" [matMenuTriggerFor]="contextMenu">more_vert
  </mat-icon>
<!-- </button> -->
<mat-menu #contextMenu="matMenu" [xPosition]="xPosition" [yPosition]="yPosition">
  @for (item of menuItems; track trackById(i, item); let i = $index) {
    <button mat-menu-item [id]="'menu' + i" [disabled]="item?.disabled"
      (click)="onItemSelected(item)">
      @if (item?.iconName) {
        <mat-icon>{{ item.iconName }}</mat-icon>
      }
      <span [id]="item?.id">{{ item.textLabel | translate }}</span>
    </button>
  }
</mat-menu>
</div>